import { api } from "api/loginRoutes";
import { createAction } from "./defaults";
import { FAKE_DLR_SET_LIST, FAKE_DLR_SUPPLIER_SET_LIST, FAKE_DLR_SET_LOADING } from "./actionTypes";
import {
    FAKE_DLR_GET_LIST_API,
    FAKE_DLR_CREATE_API,
    FAKE_DLR_MODIFY_API,
    FAKE_DLR_REMOVE_API,
    FAKE_DLR_MULTIROW_API,
    FAKE_DLR_SUPPLIER_LIST_API,
    FAKE_DLR_TEST_RULE_API
} from "const/apiMethods";
import { FAKE_DLR as PREFIX } from "const";

const setList = createAction(FAKE_DLR_SET_LIST);
const setLoading = createAction(FAKE_DLR_SET_LOADING);
const setSupplierList = createAction(FAKE_DLR_SUPPLIER_SET_LIST);

// createApi:,
// modifyApi:,
// modifyMultirowApi:,
// removeApi:,

export const createFakeDLR = (data) => async () => {
    return await api(FAKE_DLR_CREATE_API, {
        ...data
    });
};

export const modifyFakeDLR = (target, params) => async () => {
    return await api(FAKE_DLR_MODIFY_API, {
        target: target,
        ...params,
    });
};

export const removeFakeDLR = (key) => async () => {
    return await api(FAKE_DLR_REMOVE_API, {
        target: {
            "sms.fake_dlr_id": key
        }
    });
};

export const modifyMultirowFakeDLR = (targetParams, params, dataList) => async () => {
    return await api(FAKE_DLR_MULTIROW_API, {
        target: targetParams,
        data_list: dataList,
        ...params
    });
};

export const testFakeDLRRule = (data) => async () => {
    return await api(FAKE_DLR_TEST_RULE_API, data);
};

export const getFakeDLRList = (filter, page, perPage, sort) => async (dispatch) => {
    dispatch(setLoading(true));

    const { id: supplierAndTrunkId, ...restFilter } = filter || {};
    const [supplierId, trunkId] = supplierAndTrunkId ? supplierAndTrunkId.split("%") : [null, null];

    return await api(FAKE_DLR_GET_LIST_API, {
        target: {
            "sms.supplier_id": supplierId,
            "sms.supplier_trunk_id": trunkId
        },
        filter: {
            ...restFilter
        },
        page, per_page: perPage, sort
    })
        .then((response) => {
            dispatch(setList({
                list: response["sms.fake_dlr_list"] || [],
                count: response["sms.fake_dlr_count"] || 0,
                page,
                perPage
            }));
        })
        .finally(() => dispatch(setLoading(false)));
};

export const getFakeDLRSupplierList = () => async (dispatch) => {
    return await api(FAKE_DLR_SUPPLIER_LIST_API, {})
        .then((response) => {
            dispatch(setSupplierList({
                list: response["sms.supplier_list"] || []
            }));
        });
};
